const objectfit = function ($el) {
    if (!('object-fit' in document.body.style)) {
        jQuery($ => {
            let $objectFitContainer;

            if (!$el || !$el.length) {
                $objectFitContainer = $('.object-fit');
            } else {
                $objectFitContainer = $el.find('.object-fit');
            }

            $objectFitContainer.each(function () {
                let $container = $(this),
                    imgUrl = $container.find('img').prop('src'),
                    objectfitFallbackUrl = $container.find('img').data('objectfit');

                if (objectfitFallbackUrl) {
                    imgUrl = objectfitFallbackUrl;
                }

                if (imgUrl) {
                    $container
                        .css('backgroundImage', 'url(' + imgUrl + ')')
                        .addClass('compat-object-fit');
                }
            });
        });
    }
};

objectfit();

export default objectfit;



// WEBPACK FOOTER //
// ./resources/assets/js/polyfill/object-fit.js